import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: ({ dispatch }, allMessage, lang, path) => {
        return seo({ title: allMessage["help.title"], allMessage, lang });
    },
};
